/**
 * Common utility function to map last results from API response
 * @param {Object} response - API response object
 * @param {String} gameType - Game type (e.g., 'teen62', 'mogambo', 'cmeter1')
 * @returns {Array} Mapped results array with mid and win values
 */
export const mapLastResults = (response, gameType) => {
    if (!response?.success || !response?.data?.data?.res) {
        return [];
    }

    const results = response.data.data.res;

    // Map results based on game type
    switch (gameType) {
        case 'teen20c':
            return results.map(item => ({
                mid: item.mid,
                win: item.win === "1" ? "Player A" : item.win === "2" ? "Player B" : item.win,
                originalWin: item.win
            }));
        case 'teen62':
            // For teen62: "1" = "Player A", "2" = "Player B"
            return results.map(item => ({
                mid: item.mid, // Use mid as round ID
                win: item.win === "1" ? "Player A" : item.win === "2" ? "Player B" : item.win,
                originalWin: item.win // Keep original for reference
            }));
        case 'teenmuf':
            // For teenmuf: "1" = "Player A", "2" = "Player B"
            return results.map(item => ({
                mid: item.mid,
                win: item.win === "1" ? "Player A" : item.win === "2" ? "Player B" : item.win,
                originalWin: item.win
            }));
        case 'teensin':
            // For teensin: "1" = "A", "2" = "B"
            return results.map(item => ({
                mid: item.mid,
                win: item.win === "1" ? "Player A" : item.win === "2" ? "Player B" : item.win,
                originalWin: item.win
            }));
        case 'teenjoker':
            // For teenjoker: "1" = "Player A", "2" = "Player B"
            return results.map(item => ({
                mid: item.mid,
                win: item.win === "1" ? "Player A" : item.win === "2" ? "Player B" : item.win,
                originalWin: item.win
            }));
        case 'teen1':
            // For teen1: "1" = "P" (Player), "2" = "D" (Dealer)
            return results.map(item => ({
                mid: item.mid,
                win: item.win === "1" ? "P" : item.win === "2" ? "D" : item.win,
                originalWin: item.win
            }));

        case 'mogambo':
            // For mogambo: "1" = "W" (Win), "2" = "L" (Lose)
            return results.map(item => ({
                mid: item.mid,
                win: item.win === "1" ? "W" : item.win === "2" ? "L" : item.win,
                originalWin: item.win
            }));
        case 'aaa':
            // For aaa: "1" = "A", "2" = "B"
            return results.map(item => ({
                mid: item.mid,
                win: item.win === "1" ? "Amar" : item.win === "2" ? "Akbar" : item.win === "3" ? "Anthony" : item.win,
                originalWin: item.win
            }));

        case 'ab20':
            // For ab20: "1" = "A", "2" = "B"
            return results.map(item => ({
                mid: item.mid,
                win: item.win === "1" ? "Win" : item.win === "2" ? "Win" : 'Win',
                originalWin: item.win
            }));

        case 'race20':
            // For race20: "1" = "K Spade", "2" = "K Heart", "3" = "K Club", "4" = "K Diamond"
            return results.map(item => {
                let winDisplay = item.win;
                if (item.win === "1") winDisplay = "K Spade";
                else if (item.win === "2") winDisplay = "K Heart";
                else if (item.win === "3") winDisplay = "K Club";
                else if (item.win === "4") winDisplay = "K Diamond";
                return {
                    mid: item.mid,
                    win: winDisplay,
                    originalWin: item.win
                };
            });

        case 'baccarat':
            // For baccarat: "1" = "Player A", "2" = "Player B"
            return results.map(item => ({
                mid: item.mid,
                win: item.win === "1" ? "Player" : item.win === "2" ? "Banker" : item.win,
                originalWin: item.win
            }));
        case 'baccarat2':
            // For baccarat2: "1" = "Player A", "2" = "Player B"
            return results.map(item => ({
                mid: item.mid,
                win: item.win === "1" ? "Player" : item.win === "2" ? "Banker" : item.win,
                originalWin: item.win
            }));
        case 'lucky7eu':
            // For lucky7eu: "1" = "Player A", "2" = "Player B"
            return results.map(item => ({
                mid: item.mid,
                win: item.win === "1" ? "High Card" : item.win === "2" ? "Low Card" : 'Tie',
                originalWin: item.win
            }));
        default:
            // Default: return as-is with mid
            return results.map(item => ({
                mid: item.mid,
                win: item.win,
                originalWin: item.win
            }));
    }
};
